<template>
  <div class="wrapper">
    <notifications />
    <side-bar>
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'ni ni-shop text-primary',
            path: '/alternative'
          }"
        />

        <!-- Users -->
        <sidebar-item
          :link="{
            name: 'Users',
            icon: 'ni ni-ungroup text-orange'
          }"
        >
          <sidebar-item
            :link="{
              name: 'Add User',
              icon: 'ni ni-circle-08 text-red',
              path: '/users/add'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Customer List',
              icon: 'ni ni-circle-08 text-red',
              path: '/users/list'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Staff',
              icon: 'ni ni-badge text-blue',
              path: '/users/staff'
            }"
          />
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Vendors',
            icon: 'ni ni-circle-08 text-blue'
          }"
        >
          <sidebar-item
            :link="{
              name: 'Add Vendor',
              icon: 'ni ni-circle-08 text-red',
              path: '/vendors/add'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Vendors',
              icon: 'ni ni-circle-08 text-green',
              path: '/vendors/list'
            }"
          />
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Attendance',
            icon: 'ni ni-calendar-grid-58 text-blue',
            path: '/attendance'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Branches',
            icon: 'ni ni-building text-teal',
            path: '/branches'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Branch Inventory',
            icon: 'ni ni-archive-2 text-yellow',
            path: '/branch-inventory'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Stock Movements',
            icon: 'ni ni-chart-bar-32 text-blue',
            path: '/stock-movements'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Requirement List',
            icon: 'ni ni-cart text-orange',
            path: '/order-list'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Order List',
            icon: 'ni ni-bullet-list-67 text-green',
            path: '/created-orders'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Vouchers',
            icon: 'ni ni-collection text-green',
            path: '/vouchers/list'
          }"
        />
        <sidebar-item
          :link="{
            name: 'Reports',
            icon: 'ni ni-chart-pie-35 text-primary',
            path: '/reports'
          }"
        />
      </template>
      <template slot="links-after">
        <hr class="my-3" />
        <h6 class="p-0 navbar-heading text-muted">Sale</h6>
        <ul class="navbar-nav mb-md-3">
          <!-- POS -->
          <sidebar-item
            :link="{
              name: 'POS',
              icon: 'ni ni-cart text-red',
              path: '/pos'
            }"
          />
          <!-- Products -->
          <sidebar-item
            :link="{
              name: 'Products',
              icon: 'ni ni-basket text-info'
            }"
          >
            <sidebar-item
              :link="{
                name: 'Add Product',
                icon: 'ni ni-circle-08 text-red',
                path: '/products/add'
              }"
            />
            <sidebar-item
              :link="{
                name: 'Product List',
                icon: 'ni ni-circle-08 text-red',
                path: '/products/list'
              }"
            />
          </sidebar-item>

          <!-- Sales -->
          <sidebar-item
            :link="{
              name: 'Sale List',
              icon: 'ni ni-bullet-list-67 text-green',
              path: '/sales/list'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Sale Quotations',
              icon: 'ni ni-bullet-list-67 text-yellow',
              path: '/sales/quotations'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Credit Notes',
              icon: 'ni ni-bullet-list-67 text-primary',
              path: '/creditNote/list'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Customer Chalans',
              icon: 'ni ni-bullet-list-67 text-pink',
              path: '/customer-chalans'
            }"
          />
        </ul>
      </template>
      <template slot="links-after">
        <hr class="my-3" />
        <h6 class="p-0 navbar-heading text-muted">Purchase</h6>
        <ul class="navbar-nav mb-md-3">
          <!-- Purchase -->
          <sidebar-item
            :link="{
              name: 'Add Purchase',
              icon: 'ni ni-bullet-list-67 text-green',
              path: '/purchases/add'
            }"
          />

          <sidebar-item
            :link="{
              name: 'Purchase List',
              icon: 'ni ni-bullet-list-67 text-green',
              path: '/purchases/list'
            }"
          />
        </ul>
      </template>
      <template slot="links-after">
        <hr class="my-3" />
        <h6 class="p-0 navbar-heading text-muted">Service</h6>
        <ul class="navbar-nav mb-md-3">
          <sidebar-item
            :link="{
              name: 'Service Requests',
              icon: 'ni ni-badge text-orange',
              path: '/serviceRequests/list'
            }"
          />

          <sidebar-item
            :link="{
              name: 'Chalans List',
              icon: 'ni ni-bullet-list-67 text-blue',
              path: '/chalans/list'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Quotation List',
              icon: 'ni ni-bullet-list-67 text-green',
              path: '/quotations/list'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Messages',
              icon: 'ni ni-email-83 text-yellow',
              path: '/messages/list'
            }"
          />
          <sidebar-item
            :link="{
              name: 'Bill Requests',
              icon: 'ni ni-bullet-list-67 text-purple',
              path: '/billRequests/list'
            }"
          />
        </ul>
      </template>

      <template slot="links-after">
        <hr class="my-3" />
        <h6 class="p-0 navbar-heading text-muted">Masters</h6>

        <ul class="navbar-nav mb-md-3">
          <sidebar-item
            :link="{
              name: 'Service Master',
              icon: 'ni ni-circle-08 text-blue'
            }"
          >
            <!-- Service Category -->
            <sidebar-item
              :link="{
                name: 'Service Categories',
                icon: 'ni ni-bullet-list-67 text-red',
                path: '/serviceCategories/list'
              }"
            />
            <sidebar-item
              :link="{
                name: 'Services',
                icon: 'ni ni-html5',
                path: '/services/list'
              }"
            />
            <!-- Service Job -->
            <sidebar-item
              :link="{
                name: 'Service Jobs',
                icon: 'ni ni-bullet-list-67 text-yellow',
                path: '/service/jobs/list'
              }"
            />
            <!-- jobs -->
            <sidebar-item
              :link="{
                name: 'Jobs',
                icon: 'ni ni-bullet-list-67 text-green',
                path: '/jobs/list'
              }"
            />
            <!-- labour cost -->
            <sidebar-item
              :link="{
                name: 'Labor Cost',
                icon: 'ni ni-bullet-list-67 text-green',
                path: '/labor/costs/list'
              }"
            />
          </sidebar-item>

          <sidebar-item
            :link="{
              name: 'General Settings',
              icon: 'ni ni-settings-gear-65 text-red'
            }"
          >
            <!-- Expense Types -->
            <sidebar-item
              :link="{
                name: 'Expense Types',
                path: '/expenses/type/list',
                icon: 'ni ni-bullet-list-67'
              }"
            />

            <!-- Units -->
            <sidebar-item
              :link="{
                name: 'Product Units',
                icon: 'ni ni-bullet-list-67 text-red',
                path: '/product-units/list'
              }"
            />

            <!-- Payment Modes -->
            <sidebar-item
              :link="{
                name: 'Payment Modes',
                icon: 'ni ni-money-coins text-green',
                path: '/payment-modes/list'
              }"
            />

            <!-- Tax -->
            <sidebar-item
              :link="{
                name: 'Taxes',
                icon: 'ni ni-bullet-list-67 text-blue',
                path: '/taxes/list'
              }"
            />
            <!-- Roles -->
            <sidebar-item
              :link="{
                name: 'Roles',
                icon: 'ni ni-bullet-list-67 text-blue',
                path: '/roles/list'
              }"
            />

            <!-- Attributes -->
            <sidebar-item
              :link="{
                name: 'Attributes',
                icon: 'ni ni-bullet-list-67 text-yellow',
                path: '/attributes/list'
              }"
            />
            <!-- Status -->
            <sidebar-item
              :link="{
                name: 'Statuses',
                icon: 'ni ni-bullet-list-67 text-red',
                path: '/statuses/list'
              }"
            />
          </sidebar-item>
          <!-- Suppliers -->
          <sidebar-item
            :link="{
              name: 'Suppliers',
              icon: 'ni ni-delivery-fast text-info',
              path: '/suppliers/list'
            }"
          />

          <!-- Expenses -->
          <sidebar-item
            :link="{
              name: 'Expenses',
              icon: 'ni ni-money-coins text-orange',
              path: '/expenses/list'
            }"
          />
        </ul>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar
        :type="$route.meta.navbarType"
        v-if="!$route.meta.hideNavbar"
      />

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view />
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter" />
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition
  },
  mounted() {
    this.initScrollbar();
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("scrollbar-inner");
      }
    }
  }
};
</script>
<style lang="scss"></style>
